import React, { useState, useEffect } from "react";
import { Button, Stack, Typography } from "@mui/material";
// import CabBooking from "./svgImage/Morning/9AM-Morning.webp";
import CabBooking from "./svgImage/Morning/cab booking (2).webp";

import ElectricCity from "./svgImage/Morning/11-Am-Morning.webp";
// import FlightTicket from "./svgImage/Morning/Airline.webp";
// import Bank from "./svgImage/Morning/10-Am-Morning.webp";
// import FlightTicket from "./svgImage/Morning/Airline101.webp";
// import Bank from "./svgImage/Morning/Banking222.webp";
import FlightTicket from "./svgImage/Morning/Airline22.webp";
import Bank from "./svgImage/Morning/Bank Loan22.png";
import NewsPaper from "./svgImage/Morning/E-Newspaper.webp";
import NewsPaperUp from "./svgImage/Morning/7AM-MorningUp.webp";

const FrameSection1 = ({ currentIndex, setCurrentIndex }) => {
  const slides = [
    {
      id: 1,
      image: NewsPaper,
      title: "Carousel 1",
      description: "The Ultimate Show-and-Sell Tool",
      paragraph: "CarouselMarketing | BoostSales | MarketingMadeEasy",
    },
    {
      id: 2,
      // image: NewsPaperUp,
      image: FlightTicket,
      title: "Carousel 2",
      description: "Made Easy on WhatsApp",
      paragraph: "BusinessMadeEasy | ShopSmartWithWhatsApp | SeamlessShopping",
    },
    {
      id: 3,
      image: CabBooking,
      title: "Carousel 3",
      description: "Confirm with WhatsApp Breeze",
      paragraph: "SecurePayments | FastTransactions | PaymentSimplified",
    },
    {
      id: 4,
      image: Bank,
      title: "Carousel 4",
      description: "Through WhatsApp Interactive Flow",
      paragraph:
        "WhatsAppFlow | InteractiveFeedback | CustomerInsightsSimplified",
    },
    {
      id: 5,
      image: ElectricCity,
      title: "Carousel 5",
      description: "WhatsApp Business Connect",
      paragraph: "WhatsAppCalling | SeamlessSupport | TalkWithWhatsApp",
    },
  ];

  //   const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Stack
      sx={{
        position: "relative",
        width: { xl: "100%", lg: "100%", md: "100%", sm: "100%", xs: "100%" },
        height: { xl: "100%", lg: "100%", md: "100%", sm: "100%", xs: "100%" },
        margin: "auto",
        overflow: "hidden",
        borderRadius: "8px",
        // marginTop: { xl: "40px", },
        // border: "4px solid red",
      }}
    >
      {/* Slides */}
      <Stack
        direction="row"
        sx={{
          display: "flex",
          // border: "2px solid green",
          width: "100%",
          height: "100%",
          paddingLeft: { xl: "80px", lg: "80px", md: "32px", sm: "36px" },
          paddingRight: { xl: "80px", lg: "80px", md: "32px", sm: "36px" },
        }}
      >
        <img
          src={slides[currentIndex].image}
          alt={slides[currentIndex].title}
          style={{
            width: "100%",
            height: "100%",
            backgroundSize: "cover", // Ensures the image covers the entire container
            backgroundPosition: "center", // Centers the image in the container
            backgroundRepeat: "no-repeat",
            // border: "4px solid blacks",
          }}
        />
      </Stack>

      <Button
        onClick={goToPrevious}
        sx={{
          position: "absolute",
          top: { xl: "50%", lg: "50%", md: "45%", sm: "40%", xs: "24%" },
          left: { xl: "16px", lg: "16px", xs: "0px" },
          transform: {
            xl: "translateY(-50%)",
            lg: "translateY(-50%)",
            xs: "translateY(0%)",
          },
          backgroundColor: "white",
          width: "40px",
          height: "40px",
          minWidth: "unset",
          borderRadius: "50%",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        ❮
      </Button>
      <Button
        onClick={goToNext}
        sx={{
          position: "absolute",
          top: { xl: "50%", lg: "50%", md: "45%", sm: "40%", xs: "24%" },
          right: { xl: "16px", lg: "16px", xs: "0px" },
          transform: {
            xl: "translateY(-50%)",
            lg: "translateY(-50%)",
            xs: "translateY(0%)",
          },
          backgroundColor: "white",
          width: "40px",
          height: "40px",
          minWidth: "unset",
          borderRadius: "50%",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        ❯
      </Button>
    </Stack>
  );
};

export default FrameSection1;
